import { render, staticRenderFns } from "./tronscanTransfer.vue?vue&type=template&id=50ba4078&scoped=true"
import script from "./tronscanTransfer.vue?vue&type=script&lang=js"
export * from "./tronscanTransfer.vue?vue&type=script&lang=js"
import style0 from "./tronscanTransfer.vue?vue&type=style&index=0&id=50ba4078&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ba4078",
  null
  
)

export default component.exports